__turbopack_context__.v({
  "expandButton": "WJgN2a_expandButton",
  "grid": "WJgN2a_grid",
  "gridCarousel": "WJgN2a_gridCarousel",
  "gridMeta": "WJgN2a_gridMeta",
  "gridRow": "WJgN2a_gridRow",
  "header": "WJgN2a_header",
  "meta": "WJgN2a_meta",
  "title": "WJgN2a_title",
});
